import { useTranslations } from "next-intl";
import Modal from "@components/core/Modal";
import Button from "@components/core/Button";
import Link from "@components/core/Link";

function UnsubscribeModalAskCustomerService({ opened, close }) {
  const t = useTranslations("accounts");

  return (
    <Modal
      show={opened}
      onHide={close}
      title={t("unsubscribe_modal.ask_customer_service.header")}
      fullscreen="sm-down"
    >
      <div className="p-3">
        <div className="pt-3 p-sm-3 text-center h-100 d-flex flex-column justify-content-between">
          <div className="mb-4">
            <h3 className="mb-5 mx-auto" style={{ maxWidth: "380px" }}>
              {t("unsubscribe_modal.ask_customer_service.title")}
            </h3>
            <p className="mb-5">
              {t("unsubscribe_modal.ask_customer_service.argument1")}
            </p>
            <p className="mb-5">
              {t("unsubscribe_modal.ask_customer_service.argument2")}
            </p>
          </div>

          <div>
            <Link href="/catalogue">
              <Button>
                {t("unsubscribe_modal.ask_customer_service.stay")}
              </Button>
            </Link>

            <div className="py-3">
              <Link
                href={t('unsubscribe_modal.ask_customer_service.leave_link')}
                className="link-primary no-underline font-size-sm"
              >
                {t("unsubscribe_modal.ask_customer_service.leave")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default UnsubscribeModalAskCustomerService;
